module.exports = __webpack_public_path__ + "media/images/rank/check-diamond-eed74d8043e6b4e4f682f9d6c2722235.png";